/* eslint-disable @typescript-eslint/no-unsafe-argument, @typescript-eslint/no-unsafe-member-access,
@typescript-eslint/no-unsafe-return, @typescript-eslint/no-unsafe-enum-comparison */
import React from 'react';
import styled, { AnyStyledComponent } from 'styled-components';
import { LayoutItem, Text } from '@oneaudi/unified-web-components';
import {
  SYS_COLOR_CANVAS_200_DARK,
  SYS_PAGE_MARGIN,
  SYS_SPACE_FIXED_300,
} from '@oneaudi/unified-web-alpha-common';
import { Theme } from './theme';
import { AdditionalText, WltpProps, ThemeType } from '../FeatureAppTypes';
import { getThemeName } from '../../alpha-helpers';
import { darkTheme, lightTheme } from '../theme';

const LegalArea = styled.div`
  background: ${({ theme }) =>
    process.env.IS_LEGACY ? theme.global.color.canvas.default : SYS_COLOR_CANVAS_200_DARK};
`;

const StyledLayoutItem = styled(LayoutItem as AnyStyledComponent)`
  padding: ${SYS_SPACE_FIXED_300} ${SYS_PAGE_MARGIN} ${SYS_SPACE_FIXED_300} ${SYS_PAGE_MARGIN};
`;

const WltpWrapper = styled.span`
  display: block;
`;

const WltpSpan = styled.span``;

interface WltpComponentProps {
  wltp: WltpProps[];
  themeWltp: string;
  additionalText: AdditionalText;
}

export const Wltp: React.FC<WltpComponentProps> = ({ wltp, themeWltp, additionalText }) => {
  const theme = themeWltp as ThemeType;

  return (
    <Theme theme={getThemeName(theme === ThemeType.dark ? darkTheme : lightTheme)}>
      <LegalArea>
        <StyledLayoutItem basis={{ xs: '86%', m: '92%' }} shrink="0" data-testid="wltp">
          <Text
            tag="p"
            variant={{ type: 'copy', order: process.env.IS_LEGACY ? '2' : '3', style: 'normal' }}
          >
            {wltp &&
              wltp.map(
                (
                  {
                    formattedConsumption,
                    formattedEmission,
                    formattedCo2Class,
                    formattedDischargedCo2Class,
                    formattedDischargedConsumption,
                  },
                  index,
                ) => (
                  // eslint-disable-next-line react/no-array-index-key
                  <WltpWrapper key={index}>
                    {formattedConsumption && (
                      <WltpSpan data-testid="consumption">{formattedConsumption}</WltpSpan>
                    )}
                    {formattedEmission && (
                      <WltpSpan data-testid="emission">; {formattedEmission}</WltpSpan>
                    )}
                    {formattedCo2Class && (
                      <WltpSpan data-testid="co2Class">; {formattedCo2Class}</WltpSpan>
                    )}
                    {formattedDischargedConsumption && (
                      <WltpSpan data-testid="dischargedConsumption">
                        ; {formattedDischargedConsumption}
                      </WltpSpan>
                    )}
                    {formattedDischargedCo2Class && (
                      <WltpSpan data-testid="dischargedCo2Class">
                        ; {formattedDischargedCo2Class}
                      </WltpSpan>
                    )}
                  </WltpWrapper>
                ),
              )}

            {additionalText && <WltpSpan data-testid="addLegalText">{additionalText}</WltpSpan>}
          </Text>
        </StyledLayoutItem>
      </LegalArea>
    </Theme>
  );
};
